import pxToRem from "assets/theme/functions/pxToRem";

const tableHead = {
  styleOverrides: {
    root: {
      display: "",
      padding: 0,
      backgroundColor: "#F8FAFC",
      borderBottom: "1px solid #E8EDF2",

      "& .MuiTableCell-head": {
        color: "#5D6D7E",
        fontWeight: 600,
        fontSize: pxToRem(11),
        textTransform: "uppercase",
        letterSpacing: "0.4px",
        padding: `${pxToRem(10)} ${pxToRem(14)}`,
        borderBottom: "1px solid #E8EDF2",
        backgroundColor: "#F8FAFC",
      },
    },
  },
};

export default tableHead;
